import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
const refreshSession = () => {
  if (!refreshing) refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const url = cfg.url || "";
  if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/login") && !url.includes("/auth/refresh") && !url.includes("/auth/logout")) {
    cfg._retry = true;
    try { await refreshSession(); return api(cfg); } catch { /* refresh scaduto: si va al login */ }
  }
  return Promise.reject(error);
});

export const fmtErr = (detail) => {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
};

export default api;
